import { Modal, Result } from "antd";
import React, { useState } from "react";

function EditPositionUserModal(props) {
  const [submit, setSubmit] = useState(false);

  function handleCancel() {
    props.handleCancel();
  }

  return (
    <Modal
      title="Edit user"
      visible={props.visible}
      onOk={props.handleOk}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Result status="404" title="Coming soon" />
    </Modal>
  );
}

export default EditPositionUserModal;
